export default {"src":"/_next/static/media/cybus.40269975.svg","height":48,"width":160,"blurWidth":0,"blurHeight":0};